export enum EnumBannerKey {
  DOCUMENTS_CONFIGURATION = 'DOCUMENTS_CONFIGURATION',
  INTERNAL_ACCOUNT_OPENING = 'INTERNAL_ACCOUNT_OPENING',
  TDAE_URSSAF_DISCOVERY = 'TDAE_URSSAF_DISCOVERY',
  UNPAID_RECORDS = 'UNPAID_RECORDS',
  LOGIN_BANNER = 'LOGIN_BANNER',
  SPONSORSHIP = 'SPONSORSHIP',
  EMERGENCY = 'EMERGENCY',
  CORPORATE_ACTIVE = 'CORPORATE_ACTIVE',
}
